/* Generated by ai2react v0.102.0 - 2021-12-20 16:35 */
/* ai file: calidad-de-los-alumnos.ai */

import { makeAi2React } from 'ai2react'
import img0 from '././img/calidad-de-los-alumnos-large.svg'
import img1 from '././img/calidad-de-los-alumnos-mobile.svg'

const styles = `
  #g-calidad-de-los-alumnos-box ,
  #g-calidad-de-los-alumnos-box .g-artboard {
    margin:0 auto;
  }
  #g-calidad-de-los-alumnos-box p {
    margin:0;
  }
  #g-calidad-de-los-alumnos-box .g-aiAbs {
    position:absolute;
  }
  #g-calidad-de-los-alumnos-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-calidad-de-los-alumnos-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-calidad-de-los-alumnos-box .g-aiPointText p { white-space: nowrap; }
  #g-calidad-de-los-alumnos-large {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-de-los-alumnos-large p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:16px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:13px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle0 {
    line-height:65px;
    height:65px;
    letter-spacing:-0.019em;
    font-size:54px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle1 {
    font-weight:800;
    line-height:65px;
    height:65px;
    letter-spacing:0em;
    font-size:54px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle2 {
    font-weight:800;
    line-height:65px;
    height:65px;
    letter-spacing:-0.019em;
    font-size:54px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle3 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle4 {
    font-weight:800;
    line-height:18px;
    height:18px;
    letter-spacing:-0.019em;
    font-size:15px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle5 {
    height:16px;
    letter-spacing:-0.019em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle6 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:12px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle7 {
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle8 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle9 {
    font-weight:800;
    line-height:24px;
    height:24px;
    letter-spacing:0em;
    font-size:20px;
    color:rgb(188,190,192);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle10 {
    height:16px;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle11 {
    height:16px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle12 {
    height:16px;
    letter-spacing:0em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle13 {
    height:16px;
    letter-spacing:-0.043em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle14 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.054em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle15 {
    line-height:14px;
    height:14px;
    letter-spacing:0em;
    font-size:12px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle16 {
    height:16px;
    letter-spacing:-0.03em;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle17 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.052em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle18 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.06em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle19 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.066em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle20 {
    font-weight:800;
    line-height:24px;
    height:24px;
    letter-spacing:0em;
    font-size:20px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle21 {
    height:16px;
    letter-spacing:-0.03em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle22 {
    font-weight:800;
    line-height:24px;
    height:24px;
    letter-spacing:0em;
    font-size:20px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle23 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.065em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle24 {
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-los-alumnos-large .g-pstyle25 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.058em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle26 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.07em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle27 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.059em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle28 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.064em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle29 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.053em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle30 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.063em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle31 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.062em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle32 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.069em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle33 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.057em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle34 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.067em;
  }
  #g-calidad-de-los-alumnos-large .g-pstyle35 {
    line-height:15px;
    height:15px;
    letter-spacing:-0.074em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle2 {
    letter-spacing:-0.03em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle3 {
    letter-spacing:-0.039em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle4 {
    letter-spacing:-0.036em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle6 {
    letter-spacing:-0.019em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle7 {
    letter-spacing:-0.053em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle8 {
    letter-spacing:-0.034em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle9 {
    letter-spacing:-0.109em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle10 {
    letter-spacing:-0.078em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle11 {
    letter-spacing:-0.072em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle12 {
    letter-spacing:-0.116em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle13 {
    letter-spacing:-0.084em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle14 {
    letter-spacing:-0.077em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle15 {
    letter-spacing:-0.032em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle16 {
    letter-spacing:-0.065em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle17 {
    letter-spacing:-0.041em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle18 {
    letter-spacing:-0.083em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle19 {
    letter-spacing:-0.07em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle20 {
    letter-spacing:-0.11em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle21 {
    letter-spacing:-0.058em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle22 {
    letter-spacing:-0.047em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle23 {
    letter-spacing:-0.05em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle24 {
    letter-spacing:-0.043em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle25 {
    letter-spacing:-0.037em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle26 {
    letter-spacing:-0.064em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle27 {
    letter-spacing:-0.033em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle28 {
    letter-spacing:-0.075em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle29 {
    letter-spacing:-0.086em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle30 {
    letter-spacing:-0.063em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle31 {
    letter-spacing:-0.044em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle32 {
    letter-spacing:-0.035em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle33 {
    letter-spacing:-0.04em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle34 {
    letter-spacing:-0.069em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle35 {
    letter-spacing:-0.059em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle36 {
    letter-spacing:-0.066em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle37 {
    letter-spacing:-0.067em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle38 {
    letter-spacing:-0.057em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle39 {
    letter-spacing:-0.076em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle40 {
    letter-spacing:-0.073em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle41 {
    letter-spacing:-0.068em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle42 {
    letter-spacing:-0.074em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle43 {
    letter-spacing:-0.06em;
  }
  #g-calidad-de-los-alumnos-large .g-cstyle44 {
    letter-spacing:-0.119em;
  }
  #g-calidad-de-los-alumnos-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-calidad-de-los-alumnos-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:10px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:8px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle0 {
    line-height:21px;
    height:21px;
    letter-spacing:-0.019em;
    font-size:17px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle1 {
    font-weight:800;
    line-height:21px;
    height:21px;
    letter-spacing:0em;
    font-size:17px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle2 {
    font-weight:800;
    line-height:21px;
    height:21px;
    letter-spacing:-0.019em;
    font-size:17px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle3 {
    font-weight:800;
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:7px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle4 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle5 {
    height:10px;
    letter-spacing:-0.019em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle6 {
    font-weight:800;
    line-height:9px;
    height:9px;
    letter-spacing:0em;
    font-size:7px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle7 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:7px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle8 {
    font-weight:800;
    line-height:7px;
    height:7px;
    letter-spacing:-0.019em;
    font-size:6px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle9 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:0em;
    font-size:12px;
    color:rgb(188,190,192);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle10 {
    height:10px;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle11 {
    height:10px;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle12 {
    height:10px;
    letter-spacing:0em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle13 {
    height:10px;
    letter-spacing:-0.043em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle14 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.054em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle15 {
    line-height:9px;
    height:9px;
    letter-spacing:0em;
    font-size:7px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle16 {
    height:10px;
    letter-spacing:-0.03em;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle17 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.052em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle18 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.06em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle19 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.066em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle20 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:0em;
    font-size:12px;
    text-align:center;
    color:rgb(0,180,178);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle21 {
    height:10px;
    letter-spacing:-0.03em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle22 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:0em;
    font-size:12px;
    text-align:center;
    color:rgb(247,164,154);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle23 {
    height:10px;
    letter-spacing:-0.052em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle24 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.065em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle25 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:7px;
    color:rgb(255,255,255);
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle26 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.058em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle27 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.07em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle28 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.059em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle29 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.064em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle30 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.053em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle31 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.063em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle32 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.062em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle33 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.069em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle34 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.057em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle35 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.067em;
  }
  #g-calidad-de-los-alumnos-mobile .g-pstyle36 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.074em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle2 {
    letter-spacing:-0.03em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle3 {
    letter-spacing:-0.039em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle4 {
    letter-spacing:-0.036em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle6 {
    letter-spacing:-0.019em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle7 {
    letter-spacing:-0.053em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle8 {
    letter-spacing:-0.034em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle9 {
    letter-spacing:-0.109em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle10 {
    letter-spacing:-0.078em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle11 {
    letter-spacing:-0.072em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle12 {
    letter-spacing:-0.084em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle13 {
    letter-spacing:-0.077em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle14 {
    letter-spacing:-0.032em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle15 {
    letter-spacing:-0.065em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle16 {
    letter-spacing:-0.041em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle17 {
    letter-spacing:-0.083em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle18 {
    letter-spacing:-0.07em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle19 {
    letter-spacing:-0.11em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle20 {
    letter-spacing:-0.058em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle21 {
    letter-spacing:-0.047em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle22 {
    letter-spacing:-0.05em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle23 {
    letter-spacing:-0.043em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle24 {
    letter-spacing:-0.037em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle25 {
    letter-spacing:-0.064em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle26 {
    letter-spacing:-0.033em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle27 {
    letter-spacing:-0.075em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle28 {
    letter-spacing:-0.086em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle29 {
    letter-spacing:-0.063em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle30 {
    letter-spacing:-0.044em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle31 {
    letter-spacing:-0.035em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle32 {
    letter-spacing:-0.04em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle33 {
    letter-spacing:-0.069em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle34 {
    letter-spacing:-0.059em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle35 {
    letter-spacing:-0.066em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle36 {
    letter-spacing:-0.116em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle37 {
    letter-spacing:-0.067em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle38 {
    letter-spacing:-0.057em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle39 {
    letter-spacing:-0.076em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle40 {
    letter-spacing:-0.073em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle41 {
    letter-spacing:-0.068em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle42 {
    letter-spacing:-0.074em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle43 {
    letter-spacing:-0.06em;
  }
  #g-calidad-de-los-alumnos-mobile .g-cstyle44 {
    letter-spacing:-0.119em;
  }

`

const html = props => `
<div id="g-calidad-de-los-alumnos-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-calidad-de-los-alumnos-large" class="g-artboard" style="width:940px; height:1205.68669877849px;" data-aspect-ratio="0.78" data-min-width="940">
<div style=""></div>
    <img id="g-calidad-de-los-alumnos-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.4458%;margin-top:-37.6px;left:2.1276%;width:220px;">
      <p class="g-pstyle0">Ran<span class="g-cstyle0">k</span>in<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.4458%;margin-top:-37.6px;left:24.3574%;width:34px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.4458%;margin-top:-37.6px;left:25.7073%;width:697px;">
      <p class="g-pstyle2"><span class="g-cstyle0">d</span>e cal<span class="g-cstyle0">i</span>d<span class="g-cstyle0">a</span>d <span class="g-cstyle0">d</span>e <span class="g-cstyle0">l</span>os<span class="g-cstyle0"> </span>alu<span class="g-cstyle0">m</span>no<span class="g-cstyle0">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8193%;margin-top:-8.4px;left:37.3336%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle0">Í</span>n<span class="g-cstyle0">d</span>i<span class="g-cstyle0">c</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.9793%;margin-top:-10.4px;left:9.1632%;width:109px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle0">ers</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8975%;margin-top:-9.4px;left:4.1463%;width:42px;">
      <p class="g-pstyle5">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8572%;margin-top:-7.9px;left:52.3238%;width:38px;">
      <p class="g-pstyle6"><span class="g-cstyle0">R</span>K</p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8572%;margin-top:-7.9px;left:54.063%;width:25px;">
      <p class="g-pstyle6"> </p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8572%;margin-top:-7.9px;left:63.7548%;width:87px;">
      <p class="g-pstyle7">M<span class="g-cstyle0">o</span>vimie<span class="g-cstyle0">n</span>t<span class="g-cstyle0">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.7754%;margin-top:-6.9px;left:78.6847%;width:70px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">r</span>om<span class="g-cstyle0">e</span>d<span class="g-cstyle0">i</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.7754%;margin-top:-6.9px;left:90.6385%;width:70px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">r</span>om<span class="g-cstyle0">e</span>d<span class="g-cstyle0">i</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.0587%;margin-top:-9.4px;left:4.3273%;width:38px;">
      <p class="g-pstyle5"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.9354%;margin-top:-7.9px;left:35.8256%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle0">p</span>onder<span class="g-cstyle0">a</span>d<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.9354%;margin-top:-7.9px;left:52.2231%;width:40px;">
      <p class="g-pstyle3"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.9354%;margin-top:-7.9px;left:64.9311%;width:65px;">
      <p class="g-pstyle7">&rsquo;20 a <span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.9365%;margin-top:-6.9px;left:78.5037%;width:72px;">
      <p class="g-pstyle8">NEM<span class="g-cstyle0"> </span>20<span class="g-cstyle0">2</span><span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.9365%;margin-top:-6.9px;left:90.5782%;width:70px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">D</span>T 2<span class="g-cstyle0">0</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3255%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.2057%;margin-top:-9.4px;left:9.1632%;width:102px;">
      <p class="g-pstyle10"><span class="g-cstyle2">P</span>UC d<span class="g-cstyle2">e </span>C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3716%;margin-top:-9.4px;left:36.9818%;width:65px;">
      <p class="g-pstyle11"><span class="g-cstyle2">1</span>0<span class="g-cstyle3">0</span><span class="g-cstyle4">,</span><span class="g-cstyle2">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3716%;margin-top:-9.4px;left:52.8867%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3716%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3716%;margin-top:-9.4px;left:79.9214%;width:51px;">
      <p class="g-pstyle13"><span class="g-cstyle5">6</span>,7<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.413%;margin-top:-8.9px;left:91.101%;width:63px;">
      <p class="g-pstyle14">656,27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3312%;margin-top:-7.9px;left:4.8099%;width:30px;">
      <p class="g-pstyle15"><span class="g-cstyle6">1</span> </p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.9014%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.7815%;margin-top:-9.4px;left:9.1632%;width:88px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> C<span class="g-cstyle2">hi</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.8645%;margin-top:-9.4px;left:37.3739%;width:60px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle8">8</span>,<span class="g-cstyle5">8</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.8645%;margin-top:-9.4px;left:52.8566%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.8645%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.8645%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>69<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.9059%;margin-top:-8.9px;left:91.1111%;width:63px;">
      <p class="g-pstyle17">64<span class="g-cstyle9">7</span>,39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.8242%;margin-top:-7.9px;left:4.7798%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4772%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.2745%;margin-top:-9.4px;left:9.1632%;width:115px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> l<span class="g-cstyle2">os</span> A<span class="g-cstyle2">n</span>d<span class="g-cstyle2">es</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.3989%;margin-top:-8.9px;left:91.081%;width:61px;">
      <p class="g-pstyle18">62<span class="g-cstyle10">9</span>,41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4403%;margin-top:-9.4px;left:37.4342%;width:57px;">
      <p class="g-pstyle11">96<span class="g-cstyle4">,</span>61<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4403%;margin-top:-9.4px;left:52.8666%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4403%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4403%;margin-top:-9.4px;left:79.9013%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>62<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4%;margin-top:-7.9px;left:4.7898%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9702%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.7674%;margin-top:-9.4px;left:9.1632%;width:120px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">d</span>o<span class="g-cstyle2">l</span>f<span class="g-cstyle2">o </span>Ib<span class="g-cstyle2">á</span>ñ<span class="g-cstyle2">e</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9333%;margin-top:-9.4px;left:37.4342%;width:58px;">
      <p class="g-pstyle11">96<span class="g-cstyle2">,</span>1<span class="g-cstyle2">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9333%;margin-top:-9.4px;left:52.8264%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9333%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9333%;margin-top:-9.4px;left:79.9314%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>61<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9747%;margin-top:-8.9px;left:91.1111%;width:64px;">
      <p class="g-pstyle17">625,53<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.893%;margin-top:-7.9px;left:4.7496%;width:33px;">
      <p class="g-pstyle15"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai0-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3433%;margin-top:-9.4px;left:9.1632%;width:128px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">ce</span>p<span class="g-cstyle2">c</span>i<span class="g-cstyle2">ó</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.4677%;margin-top:-8.9px;left:91.0608%;width:63px;">
      <p class="g-pstyle19">59<span class="g-cstyle11">4</span>,38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.4262%;margin-top:-9.4px;left:37.4242%;width:59px;">
      <p class="g-pstyle11">9<span class="g-cstyle2">2</span>,<span class="g-cstyle2">5</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.4262%;margin-top:-9.4px;left:52.8466%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">6</span> </p>
    </div>
    <div id="g-ai0-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.4262%;margin-top:-9.4px;left:66.8916%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.4262%;margin-top:-9.4px;left:79.9013%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>56<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3859%;margin-top:-7.9px;left:4.7898%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai0-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:22.2972%;margin-top:-13.8px;left:69.2046%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.8362%;margin-top:-9.4px;left:9.1632%;width:211px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span><span class="g-cstyle12">T</span>éc<span class="g-cstyle5">n</span>ic<span class="g-cstyle5">a</span> Fe<span class="g-cstyle5">d</span>er<span class="g-cstyle5">i</span>c<span class="g-cstyle5">o Sa</span>n<span class="g-cstyle5">t</span>a<span class="g-cstyle5"> </span>Ma<span class="g-cstyle5">rí</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.9606%;margin-top:-8.9px;left:91.0608%;width:63px;">
      <p class="g-pstyle19">59<span class="g-cstyle13">9</span><span class="g-cstyle14">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0021%;margin-top:-9.4px;left:37.4443%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span>2<span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0021%;margin-top:-9.4px;left:52.8666%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai0-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0021%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0021%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.9617%;margin-top:-7.9px;left:4.7697%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">6</span> </p>
    </div>
    <div id="g-ai0-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:23.956%;margin-top:-13.8px;left:69.2462%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.412%;margin-top:-9.4px;left:9.1632%;width:120px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5">l D</span>es<span class="g-cstyle5">a</span>r<span class="g-cstyle15">r</span>o<span class="g-cstyle5">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.5365%;margin-top:-8.9px;left:91.1412%;width:64px;">
      <p class="g-pstyle17">585<span class="g-cstyle16">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.495%;margin-top:-9.4px;left:37.4141%;width:59px;">
      <p class="g-pstyle11">9<span class="g-cstyle3">0</span><span class="g-cstyle17">,</span>9<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.495%;margin-top:-9.4px;left:52.4645%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.495%;margin-top:-9.4px;left:66.8414%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai0-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.495%;margin-top:-9.4px;left:79.851%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.4547%;margin-top:-7.9px;left:4.7999%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span> </p>
    </div>
    <div id="g-ai0-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:25.2831%;margin-top:-13.8px;left:69.2046%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:27.1077%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.905%;margin-top:-9.4px;left:9.1632%;width:125px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Di<span class="g-cstyle2">ego</span> <span class="g-cstyle2">Po</span>rta<span class="g-cstyle2">le</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.9879%;margin-top:-9.4px;left:37.4242%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle3">0</span>,5<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.9879%;margin-top:-9.4px;left:52.8365%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">8</span> </p>
    </div>
    <div id="g-ai0-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.9879%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.9879%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:27.0294%;margin-top:-8.9px;left:91.0608%;width:63px;">
      <p class="g-pstyle23">58<span class="g-cstyle18">9</span>,89<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.9476%;margin-top:-7.9px;left:4.7697%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span> </p>
    </div>
    <div id="g-ai0-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.3979%;margin-top:-9.4px;left:9.1632%;width:160px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> S</span>an<span class="g-cstyle5">t</span>ia<span class="g-cstyle5">g</span>o<span class="g-cstyle5"> </span>de<span class="g-cstyle5"> C</span>h<span class="g-cstyle5">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5223%;margin-top:-8.9px;left:91.1614%;width:64px;">
      <p class="g-pstyle17">57<span class="g-cstyle19">9</span>,37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5638%;margin-top:-9.4px;left:37.4141%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle3">0</span>,5<span class="g-cstyle5">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5638%;margin-top:-9.4px;left:52.8767%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">7</span> </p>
    </div>
    <div id="g-ai0-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5638%;margin-top:-9.4px;left:66.5297%;width:39px;">
      <p class="g-pstyle10">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5638%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5235%;margin-top:-7.9px;left:4.7697%;width:32px;">
      <p class="g-pstyle15"><span class="g-cstyle6">9</span> </p>
    </div>
    <div id="g-ai0-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:28.4348%;margin-top:-13.8px;left:69.2463%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.9738%;margin-top:-9.4px;left:9.1632%;width:89px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle20">T</span>al<span class="g-cstyle2">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0982%;margin-top:-8.9px;left:91.1211%;width:62px;">
      <p class="g-pstyle17">571<span class="g-cstyle21">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0567%;margin-top:-9.4px;left:37.394%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle22">9</span>,88<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-93" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0567%;margin-top:-9.4px;left:52.8466%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">9</span> </p>
    </div>
    <div id="g-ai0-94" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0567%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0567%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.0164%;margin-top:-7.9px;left:4.4279%;width:38px;">
      <p class="g-pstyle24">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:30.0107%;margin-top:-13.8px;left:69.2462%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-98" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5865%;margin-top:-13.8px;left:68.6612%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-99" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.4667%;margin-top:-9.4px;left:9.1632%;width:133px;">
      <p class="g-pstyle10"><span class="g-cstyle2">P</span>UC d<span class="g-cstyle2">e </span><span class="g-cstyle23">V</span>a<span class="g-cstyle2">l</span>p<span class="g-cstyle2">a</span>r<span class="g-cstyle2">aí</span>s<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5496%;margin-top:-9.4px;left:37.4644%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle22">9</span><span class="g-cstyle24">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-101" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5496%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-102" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5911%;margin-top:-8.9px;left:91.1111%;width:63px;">
      <p class="g-pstyle17">575,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-103" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5496%;margin-top:-9.4px;left:52.5248%;width:37px;">
      <p class="g-pstyle21">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-104" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5496%;margin-top:-9.4px;left:79.9013%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-105" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.5093%;margin-top:-7.9px;left:4.4781%;width:36px;">
      <p class="g-pstyle24">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.9965%;margin-top:-13.8px;left:68.6612%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-107" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.9596%;margin-top:-9.4px;left:9.1632%;width:125px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2"> </span><span class="g-cstyle25">F</span><span class="g-cstyle15">r</span><span class="g-cstyle2">o</span>nt<span class="g-cstyle2">er</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-108" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.084%;margin-top:-8.9px;left:91.1313%;width:62px;">
      <p class="g-pstyle17">56<span class="g-cstyle19">9</span>,31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-109" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1255%;margin-top:-9.4px;left:37.4342%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span><span class="g-cstyle22">9</span><span class="g-cstyle5">,</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-110" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1255%;margin-top:-9.4px;left:52.4947%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-111" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1255%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-112" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1255%;margin-top:-9.4px;left:79.9113%;width:50px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-113" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.0852%;margin-top:-7.9px;left:4.448%;width:37px;">
      <p class="g-pstyle24">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-114" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6553%;margin-top:-13.8px;left:68.6612%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-115" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.5355%;margin-top:-9.4px;left:9.1632%;width:119px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle23">V</span><span class="g-cstyle2">a</span>l<span class="g-cstyle2">p</span>ar<span class="g-cstyle2">aí</span>s<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6184%;margin-top:-9.4px;left:37.4342%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span><span class="g-cstyle24">,</span>76<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-117" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6184%;margin-top:-9.4px;left:52.5047%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6184%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-119" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6184%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.6599%;margin-top:-8.9px;left:91.091%;width:63px;">
      <p class="g-pstyle25">56<span class="g-cstyle26">4</span>,27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-121" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.5781%;margin-top:-7.9px;left:4.4581%;width:38px;">
      <p class="g-pstyle24">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1482%;margin-top:-13.8px;left:68.6612%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-123" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.0284%;margin-top:-9.4px;left:9.1632%;width:144px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle27">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span>l N<span class="g-cstyle2">o</span>rt<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-124" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1113%;margin-top:-9.4px;left:37.4342%;width:57px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1113%;margin-top:-9.4px;left:52.4645%;width:39px;">
      <p class="g-pstyle21">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-126" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1113%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-127" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1113%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.1528%;margin-top:-8.9px;left:91.0407%;width:63px;">
      <p class="g-pstyle26">55<span class="g-cstyle28">8</span>,44<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-129" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.071%;margin-top:-7.9px;left:4.4178%;width:38px;">
      <p class="g-pstyle24">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-130" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.5213%;margin-top:-9.4px;left:9.1632%;width:131px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle2">st</span>r<span class="g-cstyle2">a</span>l <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6872%;margin-top:-9.4px;left:37.3639%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span><span class="g-cstyle4">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6872%;margin-top:-9.4px;left:52.4846%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6872%;margin-top:-9.4px;left:66.8917%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-134" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6872%;margin-top:-9.4px;left:79.9113%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-135" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6457%;margin-top:-8.9px;left:91.1412%;width:63px;">
      <p class="g-pstyle17">561,33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.6469%;margin-top:-7.9px;left:4.4581%;width:37px;">
      <p class="g-pstyle24">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-137" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:37.4753%;margin-top:-13.8px;left:69.2044%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-138" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.0972%;margin-top:-9.4px;left:9.1632%;width:78px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">M</span>a<span class="g-cstyle2">yo</span>r<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1801%;margin-top:-9.4px;left:37.4745%;width:58px;">
      <p class="g-pstyle11">8<span class="g-cstyle29">7</span><span class="g-cstyle4">,</span>6<span class="g-cstyle2">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1801%;margin-top:-9.4px;left:66.8917%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-141" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1801%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.2216%;margin-top:-8.9px;left:91.081%;width:64px;">
      <p class="g-pstyle27">56<span class="g-cstyle26">3</span><span class="g-cstyle16">,</span>69<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1801%;margin-top:-9.4px;left:52.5148%;width:38px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1398%;margin-top:-7.9px;left:4.4379%;width:38px;">
      <p class="g-pstyle24">16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-145" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:39.0511%;margin-top:-13.8px;left:69.2045%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-146" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.5901%;margin-top:-9.4px;left:9.1632%;width:227px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">Me</span>t<span class="g-cstyle27">r</span>o<span class="g-cstyle2">p</span>o<span class="g-cstyle2">li</span>t<span class="g-cstyle2">a</span>n<span class="g-cstyle2">a</span> <span class="g-cstyle2">de</span> Cs. d<span class="g-cstyle2">e</span> l<span class="g-cstyle2">a</span> <span class="g-cstyle2">Ed</span>u<span class="g-cstyle2">c.</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-147" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7145%;margin-top:-8.9px;left:91.1714%;width:63px;">
      <p class="g-pstyle17">551,53<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-148" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6731%;margin-top:-9.4px;left:37.394%;width:60px;">
      <p class="g-pstyle11">86,<span class="g-cstyle2">43</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6731%;margin-top:-9.4px;left:52.5047%;width:39px;">
      <p class="g-pstyle21">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6731%;margin-top:-9.4px;left:66.5297%;width:39px;">
      <p class="g-pstyle10">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6731%;margin-top:-9.4px;left:79.8812%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-152" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6327%;margin-top:-7.9px;left:4.4681%;width:37px;">
      <p class="g-pstyle24">17<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:40.627%;margin-top:-13.8px;left:69.2563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-154" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2029%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-155" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.083%;margin-top:-9.4px;left:9.1632%;width:117px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2"> </span>S<span class="g-cstyle2">e</span><span class="g-cstyle15">r</span><span class="g-cstyle2">en</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2489%;margin-top:-9.4px;left:37.4443%;width:57px;">
      <p class="g-pstyle11">86,<span class="g-cstyle2">21</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-157" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2489%;margin-top:-9.4px;left:52.4746%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2489%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-159" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2489%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">3</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2075%;margin-top:-8.9px;left:91.0709%;width:63px;">
      <p class="g-pstyle28">5<span class="g-cstyle30">4</span>5,54<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2086%;margin-top:-7.9px;left:4.4379%;width:37px;">
      <p class="g-pstyle24">18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-162" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.6589%;margin-top:-9.4px;left:9.1632%;width:147px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle27">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span>l M<span class="g-cstyle2">a</span>u<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-163" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7833%;margin-top:-8.9px;left:91.091%;width:64px;">
      <p class="g-pstyle25">53<span class="g-cstyle26">4,</span>63<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-164" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7418%;margin-top:-9.4px;left:37.404%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle2">5</span>,<span class="g-cstyle2">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-165" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7418%;margin-top:-9.4px;left:52.4947%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7418%;margin-top:-9.4px;left:66.8414%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai0-167" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7418%;margin-top:-9.4px;left:79.9013%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7015%;margin-top:-7.9px;left:4.4379%;width:38px;">
      <p class="g-pstyle24">19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-169" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:43.6129%;margin-top:-13.8px;left:69.2044%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-170" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.1518%;margin-top:-9.4px;left:9.1632%;width:103px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span>l <span class="g-cstyle2">Bí</span>o<span class="g-cstyle31">-</span>Bí<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.2762%;margin-top:-8.9px;left:91.1313%;width:63px;">
      <p class="g-pstyle17">53<span class="g-cstyle21">4</span>,13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.3177%;margin-top:-9.4px;left:37.4242%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>5<span class="g-cstyle4">,</span><span class="g-cstyle5">0</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.3177%;margin-top:-9.4px;left:52.4846%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.3177%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-175" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.3177%;margin-top:-9.4px;left:79.9515%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-176" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.1944%;margin-top:-7.9px;left:4.3977%;width:39px;">
      <p class="g-pstyle24">20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-177" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6140326109974%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6140326109974%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6140326109974%;top:45.1888%;margin-top:-13.8px;left:69.2562%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-178" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.6448%;margin-top:-9.4px;left:9.1632%;width:133px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Alb<span class="g-cstyle2">ert</span>o Hurta<span class="g-cstyle2">do</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.8106%;margin-top:-9.4px;left:37.404%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle32">4</span><span class="g-cstyle33">,</span>93<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-180" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.8106%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.8106%;margin-top:-9.4px;left:79.9113%;width:51px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-182" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.7692%;margin-top:-8.9px;left:91.1111%;width:64px;">
      <p class="g-pstyle17">542<span class="g-cstyle16">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.8106%;margin-top:-9.4px;left:52.4344%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.7703%;margin-top:-7.9px;left:4.448%;width:37px;">
      <p class="g-pstyle24">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-185" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6140326109974%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6140326109974%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6140326109974%;top:46.7646%;margin-top:-13.8px;left:69.2462%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-186" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.2206%;margin-top:-9.4px;left:9.1632%;width:123px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. San <span class="g-cstyle2">Se</span>b<span class="g-cstyle2">a</span>sti<span class="g-cstyle2">á</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-187" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.345%;margin-top:-8.9px;left:91.0608%;width:63px;">
      <p class="g-pstyle28">53<span class="g-cstyle34">8</span><span class="g-cstyle19">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3036%;margin-top:-9.4px;left:37.3639%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle32">4</span><span class="g-cstyle33">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-189" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3036%;margin-top:-9.4px;left:52.4746%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3036%;margin-top:-9.4px;left:66.8917%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-191" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3036%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.2632%;margin-top:-7.9px;left:4.4178%;width:39px;">
      <p class="g-pstyle24">22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:48.2575%;margin-top:-13.8px;left:69.2045%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-194" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.7135%;margin-top:-9.4px;left:9.1632%;width:113px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">n</span>d<span class="g-cstyle15">r</span><span class="g-cstyle2">és</span> <span class="g-cstyle2">Be</span>l<span class="g-cstyle2">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-195" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8794%;margin-top:-9.4px;left:37.404%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span><span class="g-cstyle33">,</span>9<span class="g-cstyle2">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8794%;margin-top:-9.4px;left:52.4746%;width:41px;">
      <p class="g-pstyle21">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8794%;margin-top:-9.4px;left:66.8414%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai0-198" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8794%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>03<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.838%;margin-top:-8.9px;left:91.1111%;width:63px;">
      <p class="g-pstyle29">53<span class="g-cstyle35">4</span><span class="g-cstyle36">,</span>79<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-200" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.7562%;margin-top:-7.9px;left:4.4279%;width:39px;">
      <p class="g-pstyle24">23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-201" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:49.6675%;margin-top:-13.8px;left:69.2044%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-202" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.4092%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-203" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.2065%;margin-top:-9.4px;left:9.1632%;width:206px;">
      <p class="g-pstyle10"><span class="g-cstyle2">U</span>C <span class="g-cstyle2">de l</span>a<span class="g-cstyle2"> </span>S<span class="g-cstyle2">a</span>ntí<span class="g-cstyle2">si</span>ma C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">c</span>ep<span class="g-cstyle2">ci</span>ó<span class="g-cstyle2">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.3309%;margin-top:-8.9px;left:91.0708%;width:63px;">
      <p class="g-pstyle30">532,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-205" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.3724%;margin-top:-9.4px;left:37.4242%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,82<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.3724%;margin-top:-9.4px;left:52.4344%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-207" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.3724%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-208" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.3724%;margin-top:-9.4px;left:79.8711%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.332%;margin-top:-7.9px;left:4.3977%;width:39px;">
      <p class="g-pstyle24">24<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.7823%;margin-top:-9.4px;left:9.1632%;width:107px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. F</span>i<span class="g-cstyle5">n</span>i<span class="g-cstyle5">s</span> <span class="g-cstyle12">T</span>er<span class="g-cstyle5">r</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-211" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.9068%;margin-top:-8.9px;left:91.1412%;width:64px;">
      <p class="g-pstyle17">52<span class="g-cstyle9">7</span>,43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.8653%;margin-top:-9.4px;left:37.4543%;width:58px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,81<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-213" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.8653%;margin-top:-9.4px;left:52.4645%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-214" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.8653%;margin-top:-9.4px;left:66.5398%;width:39px;">
      <p class="g-pstyle10">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-215" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.8653%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.8249%;margin-top:-7.9px;left:4.4279%;width:39px;">
      <p class="g-pstyle24">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:52.7363%;margin-top:-13.8px;left:69.2563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-218" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.2753%;margin-top:-9.4px;left:9.1632%;width:124px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> </span>M<span class="g-cstyle5">a</span>g<span class="g-cstyle5">a</span>l<span class="g-cstyle5">l</span>an<span class="g-cstyle5">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-219" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.4411%;margin-top:-9.4px;left:37.4342%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-220" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.4411%;margin-top:-9.4px;left:66.8414%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai0-221" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.4411%;margin-top:-9.4px;left:79.9113%;width:51px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-222" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.3997%;margin-top:-8.9px;left:91.0709%;width:63px;">
      <p class="g-pstyle31">5<span class="g-cstyle30">2</span><span class="g-cstyle37">8</span>,43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.4411%;margin-top:-9.4px;left:52.4444%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-224" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.3179%;margin-top:-7.9px;left:4.4078%;width:39px;">
      <p class="g-pstyle24">26<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:54.3122%;margin-top:-13.8px;left:69.2147%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-226" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.7682%;margin-top:-9.4px;left:9.1632%;width:129px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> A<span class="g-cstyle2">n</span>t<span class="g-cstyle15">o</span><span class="g-cstyle2">f</span>ag<span class="g-cstyle2">a</span>st<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.8926%;margin-top:-8.9px;left:91.091%;width:63px;">
      <p class="g-pstyle25">52<span class="g-cstyle26">4</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-228" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9341%;margin-top:-9.4px;left:37.4141%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,3<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9341%;margin-top:-9.4px;left:52.4545%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-230" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9341%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.9341%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-232" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.8937%;margin-top:-7.9px;left:4.4379%;width:39px;">
      <p class="g-pstyle24">27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-233" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:55.888%;margin-top:-13.8px;left:69.2563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-234" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.3441%;margin-top:-9.4px;left:9.1632%;width:152px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Be<span class="g-cstyle2">r</span>n<span class="g-cstyle2">a</span>r<span class="g-cstyle2">do</span> <span class="g-cstyle2">O</span>&rsquo;<span class="g-cstyle2">Hi</span>gg<span class="g-cstyle2">i</span>ns<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-235" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.427%;margin-top:-9.4px;left:37.384%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span><span class="g-cstyle4">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-236" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.427%;margin-top:-9.4px;left:52.4645%;width:41px;">
      <p class="g-pstyle10">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.427%;margin-top:-9.4px;left:66.8112%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle2">8</span> </p>
    </div>
    <div id="g-ai0-238" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.427%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.4685%;margin-top:-8.9px;left:91.1111%;width:62px;">
      <p class="g-pstyle17">51<span class="g-cstyle19">9</span><span class="g-cstyle21">,</span>66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.3867%;margin-top:-7.9px;left:4.4078%;width:39px;">
      <p class="g-pstyle24">28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-241" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:57.3809%;margin-top:-13.8px;left:69.2146%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-242" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.9568%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-243" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.837%;margin-top:-9.4px;left:9.1632%;width:112px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle20">T</span>a<span class="g-cstyle2">r</span>a<span class="g-cstyle2">pa</span>c<span class="g-cstyle2">á</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-244" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.9614%;margin-top:-8.9px;left:91.1211%;width:60px;">
      <p class="g-pstyle17">51<span class="g-cstyle21">4</span>,18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0029%;margin-top:-9.4px;left:37.404%;width:59px;">
      <p class="g-pstyle11">82<span class="g-cstyle2">,</span>8<span class="g-cstyle2">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-246" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0029%;margin-top:-9.4px;left:52.4545%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-247" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0029%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-248" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0029%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-249" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.8796%;margin-top:-7.9px;left:4.4078%;width:39px;">
      <p class="g-pstyle24">29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-250" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.3299%;margin-top:-9.4px;left:9.1632%;width:151px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle2">t</span>ó<span class="g-cstyle2">no</span>ma d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-251" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4543%;margin-top:-8.9px;left:91.1211%;width:64px;">
      <p class="g-pstyle17">52<span class="g-cstyle38">3</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-252" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4958%;margin-top:-9.4px;left:37.384%;width:60px;">
      <p class="g-pstyle11">82,<span class="g-cstyle2">4</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-253" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4958%;margin-top:-9.4px;left:52.4846%;width:40px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-254" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4958%;margin-top:-9.4px;left:66.5398%;width:39px;">
      <p class="g-pstyle10">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-255" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4958%;margin-top:-9.4px;left:79.9113%;width:52px;">
      <p class="g-pstyle10">5<span class="g-cstyle17">,</span>99<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-256" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.4555%;margin-top:-7.9px;left:4.4078%;width:40px;">
      <p class="g-pstyle24">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-257" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:60.3668%;margin-top:-13.8px;left:69.2563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-258" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9058%;margin-top:-9.4px;left:9.1632%;width:155px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle27">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span> <span class="g-cstyle12">T</span><span class="g-cstyle2">e</span>mu<span class="g-cstyle2">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-259" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9887%;margin-top:-9.4px;left:37.4745%;width:57px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>1<span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-260" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9887%;margin-top:-9.4px;left:52.4444%;width:41px;">
      <p class="g-pstyle10">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-261" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9887%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-262" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9887%;margin-top:-9.4px;left:79.9214%;width:50px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-263" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0302%;margin-top:-8.9px;left:91.0407%;width:63px;">
      <p class="g-pstyle32">506,30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-264" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9484%;margin-top:-7.9px;left:4.4581%;width:38px;">
      <p class="g-pstyle24">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-265" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6140326109974%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6140326109974%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6140326109974%;top:62.0256%;margin-top:-13.8px;left:69.256%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-266" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.3987%;margin-top:-9.4px;left:9.1632%;width:110px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> </span><span class="g-cstyle15">A</span>tac<span class="g-cstyle5">am</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-267" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5231%;margin-top:-8.9px;left:91.091%;width:62px;">
      <p class="g-pstyle33">512,46<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-268" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5646%;margin-top:-9.4px;left:37.4543%;width:56px;">
      <p class="g-pstyle11">8<span class="g-cstyle2">1</span>,<span class="g-cstyle2">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-269" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5646%;margin-top:-9.4px;left:52.4846%;width:41px;">
      <p class="g-pstyle10">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-270" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5646%;margin-top:-9.4px;left:66.8917%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-271" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5646%;margin-top:-9.4px;left:79.9415%;width:51px;">
      <p class="g-pstyle10">5<span class="g-cstyle17">,</span>95<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-272" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4413%;margin-top:-7.9px;left:4.4279%;width:39px;">
      <p class="g-pstyle24">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-273" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:63.4356%;margin-top:-13.8px;left:69.2044%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-274" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.8916%;margin-top:-9.4px;left:9.1632%;width:133px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle2">ent</span>r<span class="g-cstyle2">a</span>l d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-275" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.0575%;margin-top:-9.4px;left:37.4945%;width:56px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>1<span class="g-cstyle5">,</span>13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-276" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.0575%;margin-top:-9.4px;left:52.4746%;width:41px;">
      <p class="g-pstyle10">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-277" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.0575%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-278" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.0575%;margin-top:-9.4px;left:79.9013%;width:52px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>89<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-279" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.016%;margin-top:-8.9px;left:91.081%;width:62px;">
      <p class="g-pstyle25"><span class="g-cstyle35">5</span>1<span class="g-cstyle26">4,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-280" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.0172%;margin-top:-7.9px;left:4.4379%;width:40px;">
      <p class="g-pstyle24">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-281" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:64.9285%;margin-top:-13.8px;left:69.2561%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-282" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5873%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-283" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.4675%;margin-top:-9.4px;left:9.1632%;width:193px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle12">T</span><span class="g-cstyle2">ec</span>n<span class="g-cstyle2">o</span>l<span class="g-cstyle2">ó</span>gi<span class="g-cstyle2">ca</span> M<span class="g-cstyle2">e</span>t<span class="g-cstyle15">r</span>op<span class="g-cstyle2">o</span>lita<span class="g-cstyle2">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-284" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5919%;margin-top:-8.9px;left:91.0709%;width:62px;">
      <p class="g-pstyle30">506<span class="g-cstyle39">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-285" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5504%;margin-top:-9.4px;left:37.4141%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span><span class="g-cstyle33">,</span>9<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-286" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5504%;margin-top:-9.4px;left:52.4444%;width:41px;">
      <p class="g-pstyle10">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-287" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5504%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-288" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5504%;margin-top:-9.4px;left:79.851%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>0<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-289" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.5101%;margin-top:-7.9px;left:4.3977%;width:40px;">
      <p class="g-pstyle24">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-290" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.9604%;margin-top:-9.4px;left:9.1632%;width:104px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Artu<span class="g-cstyle27">r</span>o<span class="g-cstyle2"> P</span>r<span class="g-cstyle15">a</span><span class="g-cstyle2">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-291" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0848%;margin-top:-8.9px;left:91.0508%;width:63px;">
      <p class="g-pstyle34">50<span class="g-cstyle11">8</span><span class="g-cstyle40">,</span>05<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-292" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.1263%;margin-top:-9.4px;left:37.4242%;width:59px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span><span class="g-cstyle3">0</span><span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-293" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.1263%;margin-top:-9.4px;left:52.4545%;width:41px;">
      <p class="g-pstyle10">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-294" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.1263%;margin-top:-9.4px;left:66.8414%;width:33px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai0-295" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.1263%;margin-top:-9.4px;left:79.9214%;width:51px;">
      <p class="g-pstyle10">5<span class="g-cstyle17">,</span>92<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-296" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.003%;margin-top:-7.9px;left:4.4379%;width:39px;">
      <p class="g-pstyle24">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-297" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:67.9144%;margin-top:-13.8px;left:69.2147%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-298" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.4533%;margin-top:-9.4px;left:9.1632%;width:208px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle27">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> Raú<span class="g-cstyle2">l</span> Si<span class="g-cstyle2">l</span>va H<span class="g-cstyle2">e</span>n<span class="g-cstyle2">r</span>íq<span class="g-cstyle2">ue</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-299" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.6192%;margin-top:-9.4px;left:37.3639%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,<span class="g-cstyle2">4</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-300" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.6192%;margin-top:-9.4px;left:52.4846%;width:41px;">
      <p class="g-pstyle21"><span class="g-cstyle5">3</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-301" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.6192%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-302" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.6192%;margin-top:-9.4px;left:79.9113%;width:51px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-303" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.5777%;margin-top:-8.9px;left:91.1211%;width:60px;">
      <p class="g-pstyle17">501,18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-304" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.5789%;margin-top:-7.9px;left:4.4178%;width:40px;">
      <p class="g-pstyle24">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-305" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:69.4902%;margin-top:-13.8px;left:69.2563%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-306" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.149%;margin-top:-13.8px;left:68.6914%;width:31px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai0-307" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.0292%;margin-top:-9.4px;left:9.1632%;width:242px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">ca</span>d<span class="g-cstyle2">e</span>m<span class="g-cstyle2">ia</span> <span class="g-cstyle2">de</span> <span class="g-cstyle2">H</span>um<span class="g-cstyle2">a</span>ni<span class="g-cstyle2">s</span>mo<span class="g-cstyle2"> </span>C<span class="g-cstyle2">r</span>isti<span class="g-cstyle2">a</span>n<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-308" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1121%;margin-top:-9.4px;left:37.4242%;width:60px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-309" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1121%;margin-top:-9.4px;left:52.4947%;width:41px;">
      <p class="g-pstyle10">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-310" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1121%;margin-top:-9.4px;left:66.771%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai0-311" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1121%;margin-top:-9.4px;left:79.9214%;width:52px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>83<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-312" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.1536%;margin-top:-8.9px;left:91.0509%;width:62px;">
      <p class="g-pstyle34"><span class="g-cstyle41">50</span><span class="g-cstyle29">9</span><span class="g-cstyle42">,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-313" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.0718%;margin-top:-7.9px;left:4.448%;width:39px;">
      <p class="g-pstyle24">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-314" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.5221%;margin-top:-9.4px;left:9.1632%;width:236px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle2">P</span>l<span class="g-cstyle2">ay</span>a<span class="g-cstyle2"> </span>A<span class="g-cstyle2">n</span>c<span class="g-cstyle2">h</span>a d<span class="g-cstyle2">e</span> Cs<span class="g-cstyle2">.</span> d<span class="g-cstyle2">e </span>la E<span class="g-cstyle2">d</span>u<span class="g-cstyle2">c.</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-315" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.688%;margin-top:-9.4px;left:37.394%;width:59px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,<span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-316" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.688%;margin-top:-9.4px;left:52.5047%;width:39px;">
      <p class="g-pstyle10">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-317" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.688%;margin-top:-9.4px;left:66.5599%;width:38px;">
      <p class="g-pstyle10">-7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-318" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.688%;margin-top:-9.4px;left:79.9716%;width:48px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">1</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-319" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.6465%;margin-top:-8.9px;left:91.081%;width:63px;">
      <p class="g-pstyle27">49<span class="g-cstyle12">7</span>,4<span class="g-cstyle43">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-320" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.5647%;margin-top:-7.9px;left:4.4178%;width:39px;">
      <p class="g-pstyle24">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-321" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:72.559%;margin-top:-13.8px;left:69.2461%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-322" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.0151%;margin-top:-9.4px;left:9.1632%;width:116px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Sant<span class="g-cstyle2">o</span> <span class="g-cstyle12">T</span><span class="g-cstyle2">o</span>m<span class="g-cstyle2">á</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-323" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1395%;margin-top:-8.9px;left:91.0307%;width:62px;">
      <p class="g-pstyle35">50<span class="g-cstyle13">0</span>,20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-324" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1809%;margin-top:-9.4px;left:37.4342%;width:59px;">
      <p class="g-pstyle11">7<span class="g-cstyle22">9</span><span class="g-cstyle32">,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-325" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1809%;margin-top:-9.4px;left:52.4042%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle2">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-326" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1809%;margin-top:-9.4px;left:66.8916%;width:31px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-327" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1809%;margin-top:-9.4px;left:79.9214%;width:51px;">
      <p class="g-pstyle10">5<span class="g-cstyle17">,</span>92<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-328" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.1406%;margin-top:-7.9px;left:4.4178%;width:40px;">
      <p class="g-pstyle24">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-329" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 53.6141601665902%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 53.6141601665902%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 53.6141601665902%;top:74.0519%;margin-top:-13.8px;left:69.2044%;margin-left:-15px;width:30px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai0-330" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.5909%;margin-top:-9.4px;left:9.1632%;width:118px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> L<span class="g-cstyle2">o</span>s<span class="g-cstyle2"> </span>L<span class="g-cstyle2">a</span>g<span class="g-cstyle2">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-331" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.6739%;margin-top:-9.4px;left:37.4644%;width:59px;">
      <p class="g-pstyle11">7<span class="g-cstyle22">9</span>,<span class="g-cstyle2">5</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-332" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.6739%;margin-top:-9.4px;left:52.4645%;width:41px;">
      <p class="g-pstyle10">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-333" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.6739%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-334" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.6739%;margin-top:-9.4px;left:79.9113%;width:52px;">
      <p class="g-pstyle10">5<span class="g-cstyle17">,</span>96<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-335" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.7153%;margin-top:-8.9px;left:91.071%;width:62px;">
      <p class="g-pstyle31">49<span class="g-cstyle44">7</span><span class="g-cstyle41">,</span>08<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-336" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:75.6335%;margin-top:-7.9px;left:4.3676%;width:40px;">
      <p class="g-pstyle24">40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-337" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:75.6278%;margin-top:-13.8px;left:69.2565%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-338" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0838%;margin-top:-9.4px;left:9.1632%;width:159px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">d</span>v<span class="g-cstyle2">e</span>n<span class="g-cstyle2">ti</span>st<span class="g-cstyle2">a</span> <span class="g-cstyle2">de</span> Chil<span class="g-cstyle2">e*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-339" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2497%;margin-top:-9.4px;left:37.5247%;width:58px;">
      <p class="g-pstyle11">7<span class="g-cstyle29">7</span><span class="g-cstyle33">,</span>93<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-340" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2497%;margin-top:-9.4px;left:53.2688%;width:26px;">
      <p class="g-pstyle12"> </p>
    </div>
    <div id="g-ai0-341" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2497%;margin-top:-9.4px;left:67.2335%;width:26px;">
      <p class="g-pstyle12"> </p>
    </div>
    <div id="g-ai0-342" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2497%;margin-top:-9.4px;left:79.8912%;width:52px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>0<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-343" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2083%;margin-top:-8.9px;left:91.071%;width:62px;">
      <p class="g-pstyle31">47<span class="g-cstyle37">8</span>,22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-344" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.1264%;margin-top:-7.9px;left:4.4178%;width:38px;">
      <p class="g-pstyle24">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-345" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.5768%;margin-top:-9.4px;left:9.1632%;width:131px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle2">V</span>i<span class="g-cstyle2">ñ</span>a <span class="g-cstyle2">de</span>l M<span class="g-cstyle2">a</span>r<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-346" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7426%;margin-top:-9.4px;left:37.4443%;width:58px;">
      <p class="g-pstyle11"><span class="g-cstyle24">7</span><span class="g-cstyle4">4</span>,<span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-347" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7426%;margin-top:-9.4px;left:52.4645%;width:39px;">
      <p class="g-pstyle21">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-348" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7426%;margin-top:-9.4px;left:66.59%;width:37px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-349" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7426%;margin-top:-9.4px;left:79.9113%;width:51px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>82<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-350" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7012%;margin-top:-8.9px;left:91.0911%;width:63px;">
      <p class="g-pstyle33">452<span class="g-cstyle19">,</span>78<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-351" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.7023%;margin-top:-7.9px;left:4.3977%;width:39px;">
      <p class="g-pstyle24">42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-352" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6142877311873%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6142877311873%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6142877311873%;top:78.6966%;margin-top:-13.8px;left:69.2561%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-353" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.1526%;margin-top:-9.4px;left:9.1632%;width:136px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2">s</span> Amé<span class="g-cstyle2">r</span>i<span class="g-cstyle2">ca</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-354" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.2356%;margin-top:-9.4px;left:37.4945%;width:54px;">
      <p class="g-pstyle11">7<span class="g-cstyle8">3</span>,<span class="g-cstyle2">1</span><span class="g-cstyle1">9</span></p>
    </div>
    <div id="g-ai0-355" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.2356%;margin-top:-9.4px;left:52.4344%;width:38px;">
      <p class="g-pstyle12"><span class="g-cstyle2">4</span>2</p>
    </div>
    <div id="g-ai0-356" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.2356%;margin-top:-9.4px;left:66.59%;width:34px;">
      <p class="g-pstyle12"><span class="g-cstyle5">-</span>1</p>
    </div>
    <div id="g-ai0-357" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.2356%;margin-top:-9.4px;left:79.9415%;width:48px;">
      <p class="g-pstyle13"><span class="g-cstyle5">5</span>,7<span class="g-cstyle1">4</span></p>
    </div>
    <div id="g-ai0-358" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.277%;margin-top:-8.9px;left:91.0409%;width:59px;">
      <p class="g-pstyle26">446<span class="g-cstyle39">,</span>6<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-359" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.1952%;margin-top:-7.9px;left:4.3977%;width:40px;">
      <p class="g-pstyle24">43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-360" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 53.6140326109974%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 53.6140326109974%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 53.6140326109974%;top:80.1066%;margin-top:-13.8px;left:69.2564%;margin-left:-15px;width:30px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai0-361" class="g-ai2html-settings g-aiAbs" style="top:82.4426%;left:3.1071%;width:93.0851%;">
      <p>Fuente: www.mifuturo.cl, Mineduc // Indicadores: Promedio NEM: Es el promedio de notas de Enseñanza Media de todos los alumnos matriculados en primer año / Promedio PSU: Es el promedio de los puntajes obtenidos en las pruebas de Comprensión Lectora y Matemática de todos los alumnos matriculados en primer año // Referencia metodológica: en la tabla se aprecian las cifras que registran las instituciones en cada uno de los indicadores. Para obtener el índice ponderado, estas fueron normalizadas estadísticamente, reescalándolas respecto del máximo valor del parámetro. De esta manera, la institución que presenta el mejor desempeño en el indicador tiene 100 puntos. Se estableció como ponderación un 30% para el promedio NEM y 70% para el promedio PDT // (*) La U. Adventista de Chile ingresa por primera vez al ranking // En este ranking no se registra la información de las universidades Gabriela Mistral, de Aconcagua, del Alba, ex U. Pedro de Valdivia, Miguel de Cervantes y Bolivariana, ya que no poseen acreditación, a ellas se suman la UNIACC e Internacional SEK, que si bien cuentan con 3 años de acreditación cada una, sus umbrales de investigación son incipientes, por lo que no es posible incluirla en el Ranking de Universidades.</p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-calidad-de-los-alumnos-mobile" class="g-artboard" style="max-width: 320px;max-height: 804px" data-aspect-ratio="0.398" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 251.193% 0;"></div>
    <img id="g-calidad-de-los-alumnos-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.5199%;margin-top:-12.3px;left:6.5276%;width:86px;">
      <p class="g-pstyle0">Ran<span class="g-cstyle0">k</span>in<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.5199%;margin-top:-12.3px;left:27.5441%;width:26px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.5199%;margin-top:-12.3px;left:28.8204%;width:239px;">
      <p class="g-pstyle2"><span class="g-cstyle0">d</span>e cal<span class="g-cstyle0">i</span>d<span class="g-cstyle0">a</span>d <span class="g-cstyle0">d</span>e <span class="g-cstyle0">l</span>os<span class="g-cstyle0"> </span>alu<span class="g-cstyle0">m</span>no<span class="g-cstyle0">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.0311%;margin-top:-5.6px;left:41.4248%;width:45px;">
      <p class="g-pstyle3"><span class="g-cstyle0">Í</span>n<span class="g-cstyle0">d</span>i<span class="g-cstyle0">c</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.266%;margin-top:-6.5px;left:11.2151%;width:76px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle0">ers</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1897%;margin-top:-5.9px;left:4.2379%;width:35px;">
      <p class="g-pstyle5">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1134%;margin-top:-5.3px;left:53.4951%;width:32px;">
      <p class="g-pstyle6"><span class="g-cstyle0">R</span>K</p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1134%;margin-top:-5.3px;left:56.6723%;width:24px;">
      <p class="g-pstyle6"> </p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1134%;margin-top:-5.3px;left:59.3764%;width:63px;">
      <p class="g-pstyle7">M<span class="g-cstyle0">o</span>vimie<span class="g-cstyle0">n</span>t<span class="g-cstyle0">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.0993%;margin-top:-4.2px;left:74.4619%;width:52px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">r</span>om<span class="g-cstyle0">e</span>d<span class="g-cstyle0">i</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.0993%;margin-top:-4.2px;left:87.5481%;width:52px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">r</span>om<span class="g-cstyle0">e</span>d<span class="g-cstyle0">i</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1849%;margin-top:-5.9px;left:4.5687%;width:32px;">
      <p class="g-pstyle5"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1086%;margin-top:-5.3px;left:38.6699%;width:60px;">
      <p class="g-pstyle3"><span class="g-cstyle0">p</span>onder<span class="g-cstyle0">a</span>d<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1086%;margin-top:-5.3px;left:53.3114%;width:33px;">
      <p class="g-pstyle3"><span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1086%;margin-top:-5.3px;left:61.5255%;width:48px;">
      <p class="g-pstyle7">&rsquo;20 a <span class="g-cstyle0">&rsquo;</span>2<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.0945%;margin-top:-4.2px;left:74.1311%;width:53px;">
      <p class="g-pstyle8">NEM<span class="g-cstyle0"> </span>20<span class="g-cstyle0">2</span><span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.0945%;margin-top:-4.2px;left:87.4379%;width:52px;">
      <p class="g-pstyle8">P<span class="g-cstyle0">D</span>T 2<span class="g-cstyle0">0</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2845%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.1659%;margin-top:-5.9px;left:11.2151%;width:72px;">
      <p class="g-pstyle10"><span class="g-cstyle2">P</span>UC d<span class="g-cstyle2">e </span>C<span class="g-cstyle2">h</span>i<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2903%;margin-top:-5.9px;left:40.7821%;width:49px;">
      <p class="g-pstyle11"><span class="g-cstyle2">1</span>0<span class="g-cstyle3">0</span><span class="g-cstyle4">,</span><span class="g-cstyle2">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2903%;margin-top:-5.9px;left:54.5235%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2903%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2903%;margin-top:-5.9px;left:76.7208%;width:40px;">
      <p class="g-pstyle13"><span class="g-cstyle5">6</span>,7<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.2281%;margin-top:-5.4px;left:88.3931%;width:48px;">
      <p class="g-pstyle14">656,27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.214%;margin-top:-5.3px;left:5.4503%;width:27px;">
      <p class="g-pstyle15"><span class="g-cstyle6">1</span> </p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.653%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.5344%;margin-top:-5.9px;left:11.2151%;width:63px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> C<span class="g-cstyle2">hi</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6588%;margin-top:-5.9px;left:41.4983%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle8">8</span>,<span class="g-cstyle5">8</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6588%;margin-top:-5.9px;left:54.4686%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6588%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6588%;margin-top:-5.9px;left:76.6475%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>69<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.721%;margin-top:-5.4px;left:88.4115%;width:48px;">
      <p class="g-pstyle17">64<span class="g-cstyle9">7</span>,39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.7069%;margin-top:-5.3px;left:5.3951%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">2</span> </p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.1458%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.0273%;margin-top:-5.9px;left:11.2151%;width:80px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> l<span class="g-cstyle2">os</span> A<span class="g-cstyle2">n</span>d<span class="g-cstyle2">es</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.0895%;margin-top:-5.4px;left:88.3565%;width:47px;">
      <p class="g-pstyle18">62<span class="g-cstyle10">9</span>,41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.1517%;margin-top:-5.9px;left:41.6085%;width:44px;">
      <p class="g-pstyle11">96<span class="g-cstyle4">,</span>61<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.1517%;margin-top:-5.9px;left:54.4869%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.1517%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.1517%;margin-top:-5.9px;left:76.6842%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>62<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.0754%;margin-top:-5.3px;left:5.4137%;width:29px;">
      <p class="g-pstyle15"><span class="g-cstyle6">3</span> </p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.6387%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.3957%;margin-top:-5.9px;left:11.2151%;width:83px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">d</span>o<span class="g-cstyle2">l</span>f<span class="g-cstyle2">o </span>Ib<span class="g-cstyle2">á</span>ñ<span class="g-cstyle2">e</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5201%;margin-top:-5.9px;left:41.6085%;width:44px;">
      <p class="g-pstyle11">96<span class="g-cstyle2">,</span>1<span class="g-cstyle2">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5201%;margin-top:-5.9px;left:54.4134%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle2">4</span> </p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5201%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5201%;margin-top:-5.9px;left:76.7391%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>61<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5823%;margin-top:-5.4px;left:88.4115%;width:48px;">
      <p class="g-pstyle17">625,53<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4438%;margin-top:-5.3px;left:5.3402%;width:29px;">
      <p class="g-pstyle15"><span class="g-cstyle6">4</span> </p>
    </div>
    <div id="g-ai1-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.8886%;margin-top:-5.9px;left:11.2151%;width:88px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">ce</span>p<span class="g-cstyle2">c</span>i<span class="g-cstyle2">ó</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9508%;margin-top:-5.4px;left:88.3193%;width:48px;">
      <p class="g-pstyle19">59<span class="g-cstyle11">4</span>,38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.013%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle11">9<span class="g-cstyle2">2</span>,<span class="g-cstyle2">5</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.013%;margin-top:-5.9px;left:54.4503%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">6</span> </p>
    </div>
    <div id="g-ai1-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.013%;margin-top:-5.9px;left:65.1064%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.013%;margin-top:-5.9px;left:76.6842%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>56<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.9367%;margin-top:-5.3px;left:5.4137%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">5</span> </p>
    </div>
    <div id="g-ai1-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:20.7584%;margin-top:-8.9px;left:69.3358%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.2571%;margin-top:-5.9px;left:11.2151%;width:90px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>.T.F. Sa<span class="g-cstyle2">n</span>t<span class="g-cstyle2">a</span> <span class="g-cstyle2">Ma</span>rí<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3815%;margin-top:-5.9px;left:41.6268%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span>2<span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3815%;margin-top:-5.9px;left:54.4869%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle2">5</span> </p>
    </div>
    <div id="g-ai1-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3815%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3815%;margin-top:-5.9px;left:76.6475%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3193%;margin-top:-5.4px;left:88.3193%;width:47px;">
      <p class="g-pstyle19">59<span class="g-cstyle12">9</span><span class="g-cstyle13">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.3052%;margin-top:-5.3px;left:5.3768%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">6</span> </p>
    </div>
    <div id="g-ai1-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:22.3756%;margin-top:-8.9px;left:69.4118%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.6255%;margin-top:-5.9px;left:11.2151%;width:83px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5">l D</span>es<span class="g-cstyle5">a</span>r<span class="g-cstyle14">r</span>o<span class="g-cstyle5">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7499%;margin-top:-5.9px;left:88.4664%;width:48px;">
      <p class="g-pstyle23">585<span class="g-cstyle15">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7499%;margin-top:-5.9px;left:41.5719%;width:45px;">
      <p class="g-pstyle11">9<span class="g-cstyle3">0</span><span class="g-cstyle16">,</span>9<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7499%;margin-top:-5.9px;left:53.752%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7499%;margin-top:-5.9px;left:65.0149%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai1-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7499%;margin-top:-5.9px;left:76.5923%;width:41px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.7981%;margin-top:-5.3px;left:5.432%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">7</span> </p>
    </div>
    <div id="g-ai1-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:23.6197%;margin-top:-8.9px;left:69.3352%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.3614%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1184%;margin-top:-5.9px;left:11.2151%;width:86px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Di<span class="g-cstyle2">ego</span> <span class="g-cstyle2">Po</span>rta<span class="g-cstyle2">le</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2428%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle3">0</span>,5<span class="g-cstyle5">3</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2428%;margin-top:-5.9px;left:54.4317%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">8</span> </p>
    </div>
    <div id="g-ai1-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2428%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2428%;margin-top:-5.9px;left:76.6475%;width:40px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1806%;margin-top:-5.4px;left:88.3193%;width:47px;">
      <p class="g-pstyle24">58<span class="g-cstyle17">9</span>,89<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1665%;margin-top:-5.3px;left:5.3768%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">8</span> </p>
    </div>
    <div id="g-ai1-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4869%;margin-top:-5.9px;left:11.2151%;width:108px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> S</span>an<span class="g-cstyle5">t</span>ia<span class="g-cstyle5">g</span>o<span class="g-cstyle5"> </span>de<span class="g-cstyle5"> C</span>h<span class="g-cstyle5">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6113%;margin-top:-5.9px;left:88.503%;width:48px;">
      <p class="g-pstyle23">57<span class="g-cstyle18">9</span>,37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6113%;margin-top:-5.9px;left:41.5719%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">9</span><span class="g-cstyle3">0</span>,5<span class="g-cstyle5">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6113%;margin-top:-5.9px;left:54.5052%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">7</span> </p>
    </div>
    <div id="g-ai1-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6113%;margin-top:-5.9px;left:64.4454%;width:32px;">
      <p class="g-pstyle10">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6113%;margin-top:-5.9px;left:76.6659%;width:41px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.535%;margin-top:-5.3px;left:5.3768%;width:28px;">
      <p class="g-pstyle15"><span class="g-cstyle6">9</span> </p>
    </div>
    <div id="g-ai1-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:26.4811%;margin-top:-8.9px;left:69.4118%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:27.9798%;margin-top:-5.9px;left:11.2151%;width:64px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle19">T</span>al<span class="g-cstyle2">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.042%;margin-top:-5.4px;left:88.4298%;width:47px;">
      <p class="g-pstyle17">571<span class="g-cstyle20">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.1042%;margin-top:-5.9px;left:41.5349%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle21">9</span>,88<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-93" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.1042%;margin-top:-5.9px;left:54.4503%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">9</span> </p>
    </div>
    <div id="g-ai1-94" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.1042%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-95" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.1042%;margin-top:-5.9px;left:76.6659%;width:40px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.0279%;margin-top:-5.3px;left:4.7524%;width:32px;">
      <p class="g-pstyle25">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-97" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:27.9739%;margin-top:-8.9px;left:69.4118%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-98" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4668%;margin-top:-8.9px;left:68.3391%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-99" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.3482%;margin-top:-5.9px;left:11.2151%;width:91px;">
      <p class="g-pstyle10"><span class="g-cstyle2">P</span>UC d<span class="g-cstyle2">e </span><span class="g-cstyle22">V</span>a<span class="g-cstyle2">l</span>p<span class="g-cstyle2">a</span>r<span class="g-cstyle2">aí</span>s<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-100" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4726%;margin-top:-5.9px;left:41.6634%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle21">9</span><span class="g-cstyle23">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-101" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4726%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-102" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.5348%;margin-top:-5.4px;left:88.4115%;width:48px;">
      <p class="g-pstyle17">575,86<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-103" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4726%;margin-top:-5.9px;left:53.8625%;width:31px;">
      <p class="g-pstyle21">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-104" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.4726%;margin-top:-5.9px;left:76.6842%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-105" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.3963%;margin-top:-5.3px;left:4.8443%;width:31px;">
      <p class="g-pstyle25">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-106" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8353%;margin-top:-8.9px;left:68.3391%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-107" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.7167%;margin-top:-5.9px;left:11.2151%;width:86px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2"> </span><span class="g-cstyle24">F</span><span class="g-cstyle14">r</span><span class="g-cstyle2">o</span>nt<span class="g-cstyle2">er</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-108" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.9033%;margin-top:-5.4px;left:88.4481%;width:47px;">
      <p class="g-pstyle17">56<span class="g-cstyle18">9</span>,31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-109" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8411%;margin-top:-5.9px;left:41.6085%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span><span class="g-cstyle21">9</span><span class="g-cstyle5">,</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-110" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8411%;margin-top:-5.9px;left:53.8073%;width:32px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-111" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8411%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-112" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8411%;margin-top:-5.9px;left:76.7025%;width:39px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">4</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-113" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8892%;margin-top:-5.3px;left:4.789%;width:32px;">
      <p class="g-pstyle25">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-114" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.3282%;margin-top:-8.9px;left:68.3391%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-115" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.2096%;margin-top:-5.9px;left:11.2151%;width:82px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle22">V</span><span class="g-cstyle2">a</span>l<span class="g-cstyle2">p</span>ar<span class="g-cstyle2">aí</span>s<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-116" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.334%;margin-top:-5.9px;left:41.6085%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span><span class="g-cstyle23">,</span>76<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-117" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.334%;margin-top:-5.9px;left:53.8256%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-118" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.334%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-119" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.334%;margin-top:-5.9px;left:76.6475%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-120" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.2718%;margin-top:-5.4px;left:88.3745%;width:47px;">
      <p class="g-pstyle26">56<span class="g-cstyle25">4</span>,27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-121" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.2577%;margin-top:-5.3px;left:4.8076%;width:32px;">
      <p class="g-pstyle25">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-122" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.6966%;margin-top:-8.9px;left:68.3391%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-123" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.578%;margin-top:-5.9px;left:11.2151%;width:98px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle26">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span>l N<span class="g-cstyle2">o</span>rt<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-124" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7025%;margin-top:-5.9px;left:41.6085%;width:44px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span>,<span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-125" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7025%;margin-top:-5.9px;left:53.752%;width:33px;">
      <p class="g-pstyle21">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7025%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-127" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7025%;margin-top:-5.9px;left:76.6475%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.7647%;margin-top:-5.4px;left:88.2827%;width:47px;">
      <p class="g-pstyle27">55<span class="g-cstyle27">8</span>,44<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-129" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.6262%;margin-top:-5.3px;left:4.7341%;width:32px;">
      <p class="g-pstyle25">14<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-130" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.071%;margin-top:-5.9px;left:11.2151%;width:90px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle2">st</span>r<span class="g-cstyle2">a</span>l <span class="g-cstyle2">d</span>e Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-131" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1954%;margin-top:-5.9px;left:41.48%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">8</span><span class="g-cstyle4">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-132" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1954%;margin-top:-5.9px;left:53.789%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-133" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1954%;margin-top:-5.9px;left:65.1067%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-134" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1954%;margin-top:-5.9px;left:76.7025%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-135" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1954%;margin-top:-5.9px;left:88.4664%;width:48px;">
      <p class="g-pstyle23">561,33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-136" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.1191%;margin-top:-5.3px;left:4.8076%;width:32px;">
      <p class="g-pstyle25">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-137" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:34.9407%;margin-top:-8.9px;left:69.3355%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-138" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.4394%;margin-top:-5.9px;left:11.2151%;width:57px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">M</span>a<span class="g-cstyle2">yo</span>r<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-139" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5638%;margin-top:-5.9px;left:41.682%;width:44px;">
      <p class="g-pstyle11">8<span class="g-cstyle28">7</span><span class="g-cstyle4">,</span>6<span class="g-cstyle2">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-140" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5638%;margin-top:-5.9px;left:65.1067%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-141" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5638%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-142" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.626%;margin-top:-5.4px;left:88.3565%;width:48px;">
      <p class="g-pstyle28">56<span class="g-cstyle25">3</span><span class="g-cstyle15">,</span>69<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-143" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5638%;margin-top:-5.9px;left:53.8439%;width:32px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-144" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.4875%;margin-top:-5.3px;left:4.7707%;width:32px;">
      <p class="g-pstyle25">16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-145" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:36.4336%;margin-top:-8.9px;left:69.3355%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-146" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.8079%;margin-top:-5.9px;left:11.2151%;width:109px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">M. de</span> Cs. d<span class="g-cstyle2">e</span> l<span class="g-cstyle2">a</span> <span class="g-cstyle2">Ed</span>u<span class="g-cstyle2">c.</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-147" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9323%;margin-top:-5.9px;left:88.5213%;width:47px;">
      <p class="g-pstyle23">551,53<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-148" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9323%;margin-top:-5.9px;left:41.5349%;width:46px;">
      <p class="g-pstyle11">86,<span class="g-cstyle2">43</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9323%;margin-top:-5.9px;left:53.8256%;width:32px;">
      <p class="g-pstyle21">15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-150" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9323%;margin-top:-5.9px;left:64.4454%;width:32px;">
      <p class="g-pstyle10">-2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-151" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9323%;margin-top:-5.9px;left:76.6475%;width:40px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-152" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9804%;margin-top:-5.3px;left:4.8259%;width:31px;">
      <p class="g-pstyle25">17<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-153" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:37.9264%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-154" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.4193%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-155" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.3007%;margin-top:-5.9px;left:11.2151%;width:81px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2"> </span>S<span class="g-cstyle2">e</span><span class="g-cstyle14">r</span><span class="g-cstyle2">en</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-156" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.4251%;margin-top:-5.9px;left:41.6268%;width:44px;">
      <p class="g-pstyle11">86,<span class="g-cstyle2">21</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-157" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.4251%;margin-top:-5.9px;left:53.7703%;width:32px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.4251%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-159" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.4251%;margin-top:-5.9px;left:76.6659%;width:41px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">3</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.3629%;margin-top:-5.4px;left:88.3379%;width:48px;">
      <p class="g-pstyle29">5<span class="g-cstyle29">4</span>5,54<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.3489%;margin-top:-5.3px;left:4.7707%;width:32px;">
      <p class="g-pstyle25">18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-162" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6692%;margin-top:-5.9px;left:11.2151%;width:100px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle26">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span>l M<span class="g-cstyle2">a</span>u<span class="g-cstyle2">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-163" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7936%;margin-top:-5.9px;left:41.5532%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle2">5</span>,<span class="g-cstyle2">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7936%;margin-top:-5.9px;left:53.8073%;width:32px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-165" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7936%;margin-top:-5.9px;left:65.0149%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai1-166" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7936%;margin-top:-5.9px;left:76.6842%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-167" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.8558%;margin-top:-5.4px;left:88.3745%;width:48px;">
      <p class="g-pstyle26">53<span class="g-cstyle25">4,</span>63<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-168" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.7173%;margin-top:-5.3px;left:4.7707%;width:32px;">
      <p class="g-pstyle25">19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-169" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:40.6634%;margin-top:-8.9px;left:69.3358%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-170" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.1621%;margin-top:-5.9px;left:11.2151%;width:73px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span>l <span class="g-cstyle2">Bí</span>o<span class="g-cstyle30">-</span>Bí<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2243%;margin-top:-5.4px;left:88.4481%;width:47px;">
      <p class="g-pstyle17">53<span class="g-cstyle20">4</span>,13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2865%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>5<span class="g-cstyle4">,</span><span class="g-cstyle5">0</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2865%;margin-top:-5.9px;left:53.789%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-174" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2865%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-175" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2865%;margin-top:-5.9px;left:76.7757%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2102%;margin-top:-5.3px;left:4.6975%;width:33px;">
      <p class="g-pstyle25">20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-177" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:42.1563%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-178" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.5306%;margin-top:-5.9px;left:11.2151%;width:91px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Alb<span class="g-cstyle2">ert</span>o Hurta<span class="g-cstyle2">do</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.655%;margin-top:-5.9px;left:41.5532%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle31">4</span><span class="g-cstyle32">,</span>93<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-180" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.655%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-181" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.655%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-182" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.7172%;margin-top:-5.4px;left:88.4115%;width:48px;">
      <p class="g-pstyle17">542<span class="g-cstyle15">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-183" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.655%;margin-top:-5.9px;left:53.6971%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-184" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.5787%;margin-top:-5.3px;left:4.789%;width:32px;">
      <p class="g-pstyle25">21<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-185" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:43.6491%;margin-top:-8.9px;left:69.4118%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-186" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:44.899%;margin-top:-5.9px;left:11.2151%;width:85px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. San <span class="g-cstyle2">Se</span>b<span class="g-cstyle2">a</span>sti<span class="g-cstyle2">á</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-187" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0856%;margin-top:-5.4px;left:88.3193%;width:48px;">
      <p class="g-pstyle29">53<span class="g-cstyle33">8</span><span class="g-cstyle18">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0234%;margin-top:-5.9px;left:41.48%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle31">4</span><span class="g-cstyle32">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-189" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0234%;margin-top:-5.9px;left:53.7703%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0234%;margin-top:-5.9px;left:65.1067%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-191" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0234%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0715%;margin-top:-5.3px;left:4.7341%;width:33px;">
      <p class="g-pstyle25">22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-193" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:45.0176%;margin-top:-8.9px;left:69.3355%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-194" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.3919%;margin-top:-5.9px;left:11.2151%;width:79px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">n</span>d<span class="g-cstyle14">r</span><span class="g-cstyle2">és</span> <span class="g-cstyle2">Be</span>l<span class="g-cstyle2">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-195" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.5163%;margin-top:-5.9px;left:41.5532%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span><span class="g-cstyle32">,</span>9<span class="g-cstyle2">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.5163%;margin-top:-5.9px;left:53.7703%;width:34px;">
      <p class="g-pstyle21">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-197" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.5163%;margin-top:-5.9px;left:65.0149%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai1-198" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.5163%;margin-top:-5.9px;left:76.6659%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>03<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-199" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.4541%;margin-top:-5.4px;left:88.4115%;width:48px;">
      <p class="g-pstyle30">53<span class="g-cstyle34">4</span><span class="g-cstyle35">,</span>79<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.44%;margin-top:-5.3px;left:4.7524%;width:33px;">
      <p class="g-pstyle25">23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-201" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:46.3861%;margin-top:-8.9px;left:69.3355%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-202" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8789%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-203" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.7604%;margin-top:-5.9px;left:11.2151%;width:109px;">
      <p class="g-pstyle10"><span class="g-cstyle2">U</span>C <span class="g-cstyle2">de l</span>a<span class="g-cstyle2"> </span>S. C<span class="g-cstyle2">o</span>n<span class="g-cstyle2">c</span>ep<span class="g-cstyle2">ci</span>ó<span class="g-cstyle2">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-204" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.947%;margin-top:-5.4px;left:88.3376%;width:48px;">
      <p class="g-pstyle31">532,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-205" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8848%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,82<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8848%;margin-top:-5.9px;left:53.6971%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-207" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8848%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-208" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8848%;margin-top:-5.9px;left:76.6289%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-209" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8085%;margin-top:-5.3px;left:4.6975%;width:33px;">
      <p class="g-pstyle25">24<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-210" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.2532%;margin-top:-5.9px;left:11.2151%;width:75px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. F</span>i<span class="g-cstyle5">n</span>i<span class="g-cstyle5">s</span> <span class="g-cstyle36">T</span>er<span class="g-cstyle5">r</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-211" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3777%;margin-top:-5.9px;left:41.6451%;width:44px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,81<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3777%;margin-top:-5.9px;left:53.752%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-213" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3777%;margin-top:-5.9px;left:64.4637%;width:33px;">
      <p class="g-pstyle10">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-214" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3777%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-215" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3777%;margin-top:-5.9px;left:88.4664%;width:48px;">
      <p class="g-pstyle23">52<span class="g-cstyle9">7</span>,43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-216" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3014%;margin-top:-5.3px;left:4.7524%;width:33px;">
      <p class="g-pstyle25">25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-217" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:49.123%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-218" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.6217%;margin-top:-5.9px;left:11.2151%;width:86px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> </span>M<span class="g-cstyle5">a</span>g<span class="g-cstyle5">a</span>l<span class="g-cstyle5">l</span>an<span class="g-cstyle5">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-219" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.7461%;margin-top:-5.9px;left:41.6085%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-220" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.7461%;margin-top:-5.9px;left:65.0149%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai1-221" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.7461%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-222" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.8083%;margin-top:-5.4px;left:88.3379%;width:48px;">
      <p class="g-pstyle32">5<span class="g-cstyle29">2</span><span class="g-cstyle37">8</span>,43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-223" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.7461%;margin-top:-5.9px;left:53.7154%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-224" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.6698%;margin-top:-5.3px;left:4.7158%;width:33px;">
      <p class="g-pstyle25">26<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:50.7403%;margin-top:-8.9px;left:69.3545%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-226" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:51.9902%;margin-top:-5.9px;left:11.2151%;width:89px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> A<span class="g-cstyle2">n</span>t<span class="g-cstyle14">o</span><span class="g-cstyle2">f</span>ag<span class="g-cstyle2">a</span>st<span class="g-cstyle2">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-227" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1768%;margin-top:-5.4px;left:88.3745%;width:48px;">
      <p class="g-pstyle26">52<span class="g-cstyle25">4</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-228" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1146%;margin-top:-5.9px;left:41.5719%;width:46px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span>,3<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-229" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1146%;margin-top:-5.9px;left:53.7337%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-230" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1146%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1146%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>16<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-232" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.1627%;margin-top:-5.3px;left:4.7707%;width:32px;">
      <p class="g-pstyle25">27<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:52.2332%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-234" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.4831%;margin-top:-5.9px;left:11.2151%;width:103px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Be<span class="g-cstyle2">r</span>n<span class="g-cstyle2">a</span>r<span class="g-cstyle2">do</span> <span class="g-cstyle2">O</span>&rsquo;<span class="g-cstyle2">Hi</span>gg<span class="g-cstyle2">i</span>ns<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-235" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.6075%;margin-top:-5.9px;left:41.5166%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle8">3</span><span class="g-cstyle4">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-236" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.6075%;margin-top:-5.9px;left:53.752%;width:34px;">
      <p class="g-pstyle10">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-237" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.6075%;margin-top:-5.9px;left:64.9596%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle2">8</span> </p>
    </div>
    <div id="g-ai1-238" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.6075%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-239" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.5453%;margin-top:-5.4px;left:88.4115%;width:47px;">
      <p class="g-pstyle17">51<span class="g-cstyle18">9</span><span class="g-cstyle20">,</span>66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-240" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.5312%;margin-top:-5.3px;left:4.7158%;width:33px;">
      <p class="g-pstyle25">28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-241" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:53.4772%;margin-top:-8.9px;left:69.3541%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-242" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9701%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-243" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.8515%;margin-top:-5.9px;left:11.2151%;width:78px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle19">T</span>a<span class="g-cstyle2">r</span>a<span class="g-cstyle2">pa</span>c<span class="g-cstyle2">á</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-244" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.0381%;margin-top:-5.4px;left:88.4298%;width:46px;">
      <p class="g-pstyle17">51<span class="g-cstyle20">4</span>,18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9759%;margin-top:-5.9px;left:41.5532%;width:45px;">
      <p class="g-pstyle11">82<span class="g-cstyle2">,</span>8<span class="g-cstyle2">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-246" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9759%;margin-top:-5.9px;left:53.7337%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-247" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9759%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-248" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.9759%;margin-top:-5.9px;left:76.6659%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.8996%;margin-top:-5.3px;left:4.7158%;width:33px;">
      <p class="g-pstyle25">29<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-250" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.3444%;margin-top:-5.9px;left:11.2151%;width:102px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle2">t</span>ó<span class="g-cstyle2">no</span>ma d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-251" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4066%;margin-top:-5.4px;left:88.4298%;width:48px;">
      <p class="g-pstyle17">52<span class="g-cstyle38">3</span>,23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4688%;margin-top:-5.9px;left:41.5166%;width:45px;">
      <p class="g-pstyle11">82,<span class="g-cstyle2">4</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-253" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4688%;margin-top:-5.9px;left:53.789%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">2</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-254" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4688%;margin-top:-5.9px;left:64.4637%;width:33px;">
      <p class="g-pstyle10">-3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-255" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4688%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle16">,</span>99<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-256" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.3925%;margin-top:-5.3px;left:4.7158%;width:33px;">
      <p class="g-pstyle25">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-257" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:56.3386%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-258" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.7129%;margin-top:-5.9px;left:11.2151%;width:105px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle26">a</span>t<span class="g-cstyle2">ó</span>l<span class="g-cstyle2">ica</span> <span class="g-cstyle2">de</span> <span class="g-cstyle36">T</span><span class="g-cstyle2">e</span>mu<span class="g-cstyle2">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-259" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.8373%;margin-top:-5.9px;left:41.682%;width:44px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>1<span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.8373%;margin-top:-5.9px;left:53.7154%;width:34px;">
      <p class="g-pstyle10">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-261" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.8373%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.8373%;margin-top:-5.9px;left:76.7208%;width:39px;">
      <p class="g-pstyle10">6<span class="g-cstyle2">,</span>19<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.8995%;margin-top:-5.4px;left:88.2827%;width:47px;">
      <p class="g-pstyle33">506,30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-264" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.761%;margin-top:-5.3px;left:4.8076%;width:32px;">
      <p class="g-pstyle25">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-265" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:57.8315%;margin-top:-8.9px;left:69.4295%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-266" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.0813%;margin-top:-5.9px;left:11.2151%;width:77px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> </span><span class="g-cstyle14">A</span>tac<span class="g-cstyle5">am</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-267" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.268%;margin-top:-5.4px;left:88.3745%;width:47px;">
      <p class="g-pstyle34">512,46<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-268" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2058%;margin-top:-5.9px;left:41.6451%;width:43px;">
      <p class="g-pstyle11">8<span class="g-cstyle2">1</span>,<span class="g-cstyle2">1</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-269" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2058%;margin-top:-5.9px;left:53.789%;width:34px;">
      <p class="g-pstyle10">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-270" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2058%;margin-top:-5.9px;left:65.1067%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-271" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2058%;margin-top:-5.9px;left:76.7574%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle16">,</span>95<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-272" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2539%;margin-top:-5.3px;left:4.7524%;width:33px;">
      <p class="g-pstyle25">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:59.1999%;margin-top:-8.9px;left:69.3358%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-274" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.5742%;margin-top:-5.9px;left:11.2151%;width:91px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C<span class="g-cstyle2">ent</span>r<span class="g-cstyle2">a</span>l d<span class="g-cstyle2">e</span> Ch<span class="g-cstyle2">i</span>l<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-275" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6986%;margin-top:-5.9px;left:41.7186%;width:43px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span>1<span class="g-cstyle5">,</span>13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6986%;margin-top:-5.9px;left:53.7703%;width:34px;">
      <p class="g-pstyle10">32<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6986%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-278" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6986%;margin-top:-5.9px;left:76.6842%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>89<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-279" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6364%;margin-top:-5.4px;left:88.3565%;width:47px;">
      <p class="g-pstyle26"><span class="g-cstyle34">5</span>1<span class="g-cstyle25">4,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-280" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.6223%;margin-top:-5.3px;left:4.7707%;width:33px;">
      <p class="g-pstyle25">33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:60.5684%;margin-top:-8.9px;left:69.4298%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-282" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.1857%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-283" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9427%;margin-top:-5.9px;left:11.2151%;width:90px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle36">T. </span>M<span class="g-cstyle2">e</span>t<span class="g-cstyle14">r</span>op<span class="g-cstyle2">o</span>lita<span class="g-cstyle2">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-284" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.1293%;margin-top:-5.4px;left:88.3379%;width:47px;">
      <p class="g-pstyle31">506<span class="g-cstyle39">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-285" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0671%;margin-top:-5.9px;left:41.5719%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span><span class="g-cstyle32">,</span>9<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0671%;margin-top:-5.9px;left:53.7154%;width:34px;">
      <p class="g-pstyle10">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-287" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0671%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-288" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0671%;margin-top:-5.9px;left:76.592%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>0<span class="g-cstyle2">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-289" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9908%;margin-top:-5.3px;left:4.6975%;width:33px;">
      <p class="g-pstyle25">34<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-290" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4356%;margin-top:-5.9px;left:11.2151%;width:73px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Artu<span class="g-cstyle26">r</span>o<span class="g-cstyle2"> P</span>r<span class="g-cstyle14">a</span><span class="g-cstyle2">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-291" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4978%;margin-top:-5.4px;left:88.301%;width:47px;">
      <p class="g-pstyle35">50<span class="g-cstyle11">8</span><span class="g-cstyle40">,</span>05<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-292" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.56%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle16"><span class="g-cstyle5">8</span><span class="g-cstyle3">0</span><span class="g-cstyle5">,</span>55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-293" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.56%;margin-top:-5.9px;left:53.7337%;width:34px;">
      <p class="g-pstyle10">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-294" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.56%;margin-top:-5.9px;left:65.0149%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai1-295" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.56%;margin-top:-5.9px;left:76.7208%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle16">,</span>92<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-296" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4837%;margin-top:-5.3px;left:4.7707%;width:33px;">
      <p class="g-pstyle25">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-297" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:63.3053%;margin-top:-8.9px;left:69.3541%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-298" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.804%;margin-top:-5.9px;left:11.2151%;width:116px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. C. Raú<span class="g-cstyle2">l</span> Si<span class="g-cstyle2">l</span>va H<span class="g-cstyle2">e</span>n<span class="g-cstyle2">r</span>íq<span class="g-cstyle2">ue</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-299" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9284%;margin-top:-5.9px;left:41.48%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,<span class="g-cstyle2">4</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-300" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9284%;margin-top:-5.9px;left:53.789%;width:34px;">
      <p class="g-pstyle21"><span class="g-cstyle5">3</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-301" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9284%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-302" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9284%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>07<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-303" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9907%;margin-top:-5.4px;left:88.4298%;width:46px;">
      <p class="g-pstyle17">501,18<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-304" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.8522%;margin-top:-5.3px;left:4.7341%;width:33px;">
      <p class="g-pstyle25">36<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-305" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:64.7982%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-306" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.4155%;margin-top:-8.9px;left:68.3944%;width:27px;">
      <p class="g-pstyle9">&bull;</p>
    </div>
    <div id="g-ai1-307" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.1725%;margin-top:-5.9px;left:11.2151%;width:96px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A. <span class="g-cstyle2">de</span> <span class="g-cstyle2">H. </span>C<span class="g-cstyle2">r</span>isti<span class="g-cstyle2">a</span>n<span class="g-cstyle2">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-308" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.2969%;margin-top:-5.9px;left:41.5902%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-309" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.2969%;margin-top:-5.9px;left:53.8073%;width:34px;">
      <p class="g-pstyle10">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-310" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.2969%;margin-top:-5.9px;left:64.8861%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">=</span> </p>
    </div>
    <div id="g-ai1-311" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.2969%;margin-top:-5.9px;left:76.7208%;width:41px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>83<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-312" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.3591%;margin-top:-5.4px;left:88.3013%;width:47px;">
      <p class="g-pstyle35"><span class="g-cstyle41">50</span><span class="g-cstyle28">9</span><span class="g-cstyle42">,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-313" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.345%;margin-top:-5.3px;left:4.789%;width:33px;">
      <p class="g-pstyle25">37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-314" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.6654%;margin-top:-5.9px;left:11.2151%;width:114px;">
      <p class="g-pstyle21"><span class="g-cstyle7">U</span><span class="g-cstyle5">. </span>de<span class="g-cstyle5"> </span>Pla. A. <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> Cs</span>.<span class="g-cstyle5"> E</span>d<span class="g-cstyle5">u</span>c.<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-315" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7898%;margin-top:-5.9px;left:41.5349%;width:45px;">
      <p class="g-pstyle11">8<span class="g-cstyle3">0</span>,<span class="g-cstyle2">2</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-316" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7898%;margin-top:-5.9px;left:53.8256%;width:33px;">
      <p class="g-pstyle10">31<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-317" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7898%;margin-top:-5.9px;left:64.5006%;width:32px;">
      <p class="g-pstyle10">-7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-318" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7898%;margin-top:-5.9px;left:76.8126%;width:38px;">
      <p class="g-pstyle21"><span class="g-cstyle5">6</span>,<span class="g-cstyle5">1</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-319" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7276%;margin-top:-5.4px;left:88.3565%;width:47px;">
      <p class="g-pstyle28">49<span class="g-cstyle36">7</span>,4<span class="g-cstyle43">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-320" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:67.7135%;margin-top:-5.3px;left:4.7341%;width:33px;">
      <p class="g-pstyle25">38<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-321" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:67.6596%;margin-top:-8.9px;left:69.4115%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-322" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.0339%;margin-top:-5.9px;left:11.2151%;width:81px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. Sant<span class="g-cstyle2">o</span> <span class="g-cstyle36">T</span><span class="g-cstyle2">o</span>m<span class="g-cstyle2">á</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-323" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.1583%;margin-top:-5.9px;left:41.6085%;width:45px;">
      <p class="g-pstyle11">7<span class="g-cstyle21">9</span><span class="g-cstyle31">,</span>68<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-324" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.1583%;margin-top:-5.9px;left:53.6422%;width:34px;">
      <p class="g-pstyle10"><span class="g-cstyle2">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-325" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.1583%;margin-top:-5.9px;left:65.1064%;width:28px;">
      <p class="g-pstyle12"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-326" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.1583%;margin-top:-5.9px;left:76.7208%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle16">,</span>92<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-327" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.2205%;margin-top:-5.4px;left:88.2644%;width:47px;">
      <p class="g-pstyle36">50<span class="g-cstyle12">0</span>,20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-328" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.082%;margin-top:-5.3px;left:4.7341%;width:33px;">
      <p class="g-pstyle25">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-329" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,-1,1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,-1,1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,-1,1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:69.028%;margin-top:-8.9px;left:69.3358%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle20">&rsaquo;</p>
    </div>
    <div id="g-ai1-330" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5267%;margin-top:-5.9px;left:11.2151%;width:82px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> L<span class="g-cstyle2">o</span>s<span class="g-cstyle2"> </span>L<span class="g-cstyle2">a</span>g<span class="g-cstyle2">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-331" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6511%;margin-top:-5.9px;left:41.6634%;width:45px;">
      <p class="g-pstyle11">7<span class="g-cstyle21">9</span>,<span class="g-cstyle2">5</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-332" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6511%;margin-top:-5.9px;left:53.752%;width:34px;">
      <p class="g-pstyle10">39<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-333" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6511%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-334" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6511%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle16">,</span>96<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-335" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5889%;margin-top:-5.4px;left:88.3382%;width:47px;">
      <p class="g-pstyle32">49<span class="g-cstyle44">7</span><span class="g-cstyle41">,</span>08<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-336" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5748%;margin-top:-5.3px;left:4.6422%;width:33px;">
      <p class="g-pstyle25">40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-337" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:70.5209%;margin-top:-8.9px;left:69.4307%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-338" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.8952%;margin-top:-5.9px;left:11.2151%;width:107px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. A<span class="g-cstyle2">d</span>v<span class="g-cstyle2">e</span>n<span class="g-cstyle2">ti</span>st<span class="g-cstyle2">a</span> <span class="g-cstyle2">de</span> Chil<span class="g-cstyle2">e*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-339" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0196%;margin-top:-5.9px;left:41.7739%;width:44px;">
      <p class="g-pstyle11">7<span class="g-cstyle28">7</span><span class="g-cstyle32">,</span>93<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-340" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0196%;margin-top:-5.9px;left:55.2215%;width:24px;">
      <p class="g-pstyle12"> </p>
    </div>
    <div id="g-ai1-341" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0196%;margin-top:-5.9px;left:65.7308%;width:24px;">
      <p class="g-pstyle12"> </p>
    </div>
    <div id="g-ai1-342" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0196%;margin-top:-5.9px;left:76.6659%;width:40px;">
      <p class="g-pstyle10">6<span class="g-cstyle4">,</span>0<span class="g-cstyle2">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-343" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.0818%;margin-top:-5.4px;left:88.3382%;width:47px;">
      <p class="g-pstyle32">47<span class="g-cstyle37">8</span>,22<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-344" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.9433%;margin-top:-5.3px;left:4.7341%;width:32px;">
      <p class="g-pstyle25">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-345" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.2637%;margin-top:-5.9px;left:11.2151%;width:90px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> <span class="g-cstyle2">V</span>i<span class="g-cstyle2">ñ</span>a <span class="g-cstyle2">de</span>l M<span class="g-cstyle2">a</span>r<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-346" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.5125%;margin-top:-5.9px;left:41.6268%;width:45px;">
      <p class="g-pstyle11"><span class="g-cstyle23">7</span><span class="g-cstyle4">4</span>,<span class="g-cstyle2">2</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-347" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.5125%;margin-top:-5.9px;left:53.752%;width:33px;">
      <p class="g-pstyle21">41<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-348" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.5125%;margin-top:-5.9px;left:64.5556%;width:31px;">
      <p class="g-pstyle21"><span class="g-cstyle5">-</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-349" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.5125%;margin-top:-5.9px;left:76.7025%;width:40px;">
      <p class="g-pstyle10">5<span class="g-cstyle2">,</span>82<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-350" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.4503%;margin-top:-5.4px;left:88.3748%;width:47px;">
      <p class="g-pstyle34">452<span class="g-cstyle18">,</span>78<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-351" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.4362%;margin-top:-5.3px;left:4.6975%;width:33px;">
      <p class="g-pstyle25">42<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-352" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:73.3822%;margin-top:-8.9px;left:69.4298%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-353" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.7565%;margin-top:-5.9px;left:11.2151%;width:93px;">
      <p class="g-pstyle10"><span class="g-cstyle7">U</span>. <span class="g-cstyle2">de</span> La<span class="g-cstyle2">s</span> Amé<span class="g-cstyle2">r</span>i<span class="g-cstyle2">ca</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-354" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.881%;margin-top:-5.9px;left:41.7186%;width:42px;">
      <p class="g-pstyle11">7<span class="g-cstyle8">3</span>,<span class="g-cstyle2">1</span><span class="g-cstyle1">9</span></p>
    </div>
    <div id="g-ai1-355" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.881%;margin-top:-5.9px;left:53.6971%;width:32px;">
      <p class="g-pstyle12"><span class="g-cstyle2">4</span>2</p>
    </div>
    <div id="g-ai1-356" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.881%;margin-top:-5.9px;left:64.5556%;width:29px;">
      <p class="g-pstyle12"><span class="g-cstyle5">-</span>1</p>
    </div>
    <div id="g-ai1-357" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.881%;margin-top:-5.9px;left:76.7574%;width:38px;">
      <p class="g-pstyle13"><span class="g-cstyle5">5</span>,7<span class="g-cstyle1">4</span></p>
    </div>
    <div id="g-ai1-358" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.8188%;margin-top:-5.4px;left:88.2833%;width:45px;">
      <p class="g-pstyle27">446<span class="g-cstyle39">,</span>6<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-359" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.8047%;margin-top:-5.3px;left:4.6975%;width:33px;">
      <p class="g-pstyle25">43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-360" class="g-ai2html-settings g-aiAbs g-aiPointText" style="transform: matrix(0,1,-1,0,0,0);transform-origin: 50% 55.6437389770723%;-webkit-transform: matrix(0,1,-1,0,0,0);-webkit-transform-origin: 50% 55.6437389770723%;-ms-transform: matrix(0,1,-1,0,0,0);-ms-transform-origin: 50% 55.6437389770723%;top:74.7507%;margin-top:-8.9px;left:69.4301%;margin-left:-13.5px;width:27px;">
      <p class="g-pstyle22">&rsaquo;</p>
    </div>
    <div id="g-ai1-361" class="g-ai2html-settings g-aiAbs" style="top:76.8831%;left:0.4647%;width:97.5%;">
      <p>Fuente: www.mifuturo.cl, Mineduc // Indicadores: Promedio NEM: Es el promedio de notas de Enseñanza Media de todos los alumnos matriculados en primer año / Promedio PSU: Es el promedio de los puntajes obtenidos en las pruebas de Comprensión Lectora y Matemática de todos los alumnos matriculados en primer año // Referencia metodológica: en la tabla se aprecian las cifras que registran las instituciones en cada uno de los indicadores. Para obtener el índice ponderado, estas fueron normalizadas estadísticamente, reescalándolas respecto del máximo valor del parámetro. De esta manera, la institución que presenta el mejor desempeño en el indicador tiene 100 puntos. Se estableció como ponderación un 30% para el promedio NEM y 70% para el promedio PDT // (*) La U. Adventista de Chile ingresa por primera vez al ranking // En este ranking no se registra la información de las universidades Gabriela Mistral, de Aconcagua, del Alba, ex U. Pedro de Valdivia, Miguel de Cervantes y Bolivariana, ya que no poseen acreditación, a ellas se suman la UNIACC e Internacional SEK, que si bien cuentan con 3 años de acreditación cada una, sus umbrales de investigación son incipientes, por lo que no es posible incluirla en el Ranking de Universidades.</p>
    </div>
  </div>


</div>
`

const containerId = 'g-calidad-de-los-alumnos-box'
const namespace = 'g-'
const name = 'calidad-de-los-alumnos'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-20 16:35 */
